export default "__VITE_ASSET__4JMZWjGP__"